import React, { useState, useEffect, useContext } from 'react'
import { useParams, Redirect } from 'react-router-dom'

import { Message } from 'primereact/message'
import { PodsService } from '../../services/Pods'
import { VirtualMachineService } from '../../services/VirtualMachine'
import { Context } from '../../Context'
import { GLOBALS } from '../../utils/Globals'
import { PodForm } from '../../components/PodForm'
import { Layout } from '../../components/Layout'

import './styles.scss'
export const CreateEditPods = () => {
  const { id: idToEdit } = useParams()
  const { isAuth: token } = useContext(Context)

  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  const [PodToEdit, setPodToEdit] = useState([])
  const [virtualMachineList, setvirtualMachineList] = useState([])
  const [virtualMachineListToEdit, setvirtualMachineListToEdit] = useState([])
  const [redirectTo, setRedirectTo] = useState(null)

  const config = {
    title: 'Crear Pod',
    icon: GLOBALS.menu.pods.icon,
    link: GLOBALS.menu.pods.link,
    linkList: GLOBALS.menu.pods.linkList,
  }

  if (idToEdit) {
    config.title = 'Editar Pod'
  }

  const fetchData = async () => {
    try {
      setIsLoading(true)
      const [Pod, virtualMachineList, virtualMachineListToEdit] = await Promise.all([
        (async () => {
          if (idToEdit) {
            return await PodsService.getById(idToEdit, token)
          }
          return null
        })(),
        VirtualMachineService.virtualmachinesxemptypod(token),
        (async () => {
          if (idToEdit) {
            try {
              return await VirtualMachineService.virtualmachinesxpod(idToEdit, token)
            } catch (error) {
              return [] 
            }
          }
          return null
        })()
      ])

      setPodToEdit(Pod)

      setvirtualMachineList(
        virtualMachineList.map((u) => {
          return {
            label: `${u.display_name} - ${u.ip}`,
            value: u.id,
          }
        }))

      if (idToEdit) {
        if (virtualMachineListToEdit) {
          setvirtualMachineListToEdit(
            virtualMachineListToEdit.map((u) => {
              return {
                label: `${u.display_name} - ${u.ip}`,
                value: u.id,
              }
            }))
        }
      }

    } catch (e) {
      setError(e.message)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = async (data) => {
    try {
      setIsLoading(true)

      if (idToEdit) {
        await PodsService.update(idToEdit, data, token)
      } else {
        await PodsService.create(data, token)
      }

      setIsLoading(false)
      setError(null)

      setRedirectTo({
        pathname: config.linkList,
        state: { success: true },
      })
    } catch (e) {
      setIsLoading(false)
      setError(e.message)
    }
  }

  if (redirectTo) {
    return <Redirect to={redirectTo} />
  }

  return (
    <Layout>
      {isLoading || (!PodToEdit && idToEdit) ? (
          <div className="loading-container">
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '4em' }}></i>
        </div>
      ) : error ? (
        <Message severity="error" text={error}></Message>
      ) : (
        <div className="p-fluid">
          <div className="p-grid">
            <div className="p-col-12">
              <div className="card card-w-title">
                <h1 className="create-edit-title">
                  {config.icon && <i className={config.icon}></i>}
                  {config.title}
                </h1>

                <PodForm
                  item={PodToEdit}
                  isLoading={isLoading}
                  virtualMachineList={virtualMachineList}
                  virtualMachineListToEdit={virtualMachineListToEdit}
                  onSubmit={onSubmit}
                  cancelLink={config.linkList}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  )
}
